var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25124 8.75042L11.4676 6.31323L7.25124 3.87605V8.75042ZM16.6425 2.38936C16.7481 2.77119 16.8213 3.283 16.87 3.93291C16.9269 4.58283 16.9512 5.14338 16.9512 5.63082L17 6.31323C17 8.09238 16.87 9.40034 16.6425 10.2371C16.4394 10.9683 15.9682 11.4394 15.2371 11.6425C14.8553 11.7482 14.1566 11.8213 13.0842 11.87C12.0281 11.9269 11.0614 11.9513 10.1677 11.9513L8.87603 12C5.47209 12 3.35174 11.87 2.51497 11.6425C1.78382 11.4394 1.31263 10.9683 1.10953 10.2371C1.00392 9.85528 0.930802 9.34347 0.882059 8.69355C0.825191 8.04364 0.800819 7.48308 0.800819 6.99564L0.752075 6.31323C0.752075 4.53409 0.882059 3.22613 1.10953 2.38936C1.31263 1.65821 1.78382 1.18702 2.51497 0.983919C2.8968 0.878307 3.59546 0.805192 4.66782 0.756448C5.72394 0.69958 6.69069 0.675209 7.58432 0.675209L8.87603 0.626465C12.28 0.626465 14.4003 0.756448 15.2371 0.983919C15.9682 1.18702 16.4394 1.65821 16.6425 2.38936Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b07ad11d38f24cc1121ba487be4609aa.svg";
export { ForwardRef as ReactComponent };